import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';

export function useGetKeyFromFillOfListOfActiveItem<T extends keyof FillObject>(key: T): FillObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'list' in item && item.list.fill[key] !== undefined) {
      return item.list.fill[key];
    }

    return undefined;
  });
}
